import { COMMON, CONFIGURATION, USERMANAGEMENT, PROCESSINGITEMS } from "../../constants/action-types";

const initialState = {
  seedList: [],
  seedSMSList: [],
  testList: [],
  testSMSList: [],
  unsubscribeText: [],
  trackingParams: [],
  replyAddresses: [],
  fromAddresses: [],
  fromName: [],
  helpSMSEmail: [],
  fromNumbers: [],
  seedConfigList: [],
  testConfigList: [],
  seedSMSConfigList: [],
  testSMSConfigList: [],
  integrationList: [],
  categorizedIntegrationList: [],
  providerCategories: [],
  integrationParams: [],
  appendTrackingParams: [],
  provider: [],
  dataintegrationlogs: [],
  loading: false,
  gridloading: false,
  companies: null,
  usersByClient: null,
  addedUser: null,
  updatedUser: null,
  getUserById: null,
  checkUserPassword: null,
  clientRoles: null,
  menuList: [],
  // The client `menuList` describes. Lets DROP_DOWN_CLICK tell a real client switch
  // (stale rows, must clear) from a re-select of the current client (rows still good).
  menuClientId: null,
  clientSettings: [],
  showWelcomePopup: true,
  accountManagersOptions: [],
  manage_columns: [],
  sms_phone_numbers: [],
  beeCommenting: [],
  sms_smart_encoding: [],
  userTrustedDevices: [], 
  ampAmpSupport: [],
  
  // Premium Integration Wizard
  providerMetadata: null,
  providerMetadataLoading: false,
  providerMetadataError: null,
  connectionTestResult: null,
  connectionTestLoading: false,
  connectionTestError: null,
};
 
const Configuration = (state = initialState, action) => {
  switch (action.type) {
    case CONFIGURATION.GET_SEEDLIST_FROM_CONFIGURATIONLIST: {
      return Object.assign({}, state, {
        seedConfigList: action.payload,
      });
    }
    case CONFIGURATION.GET_SMS_SEEDLIST_FROM_CONFIGURATIONLIST: {
      return Object.assign({}, state, {
        seedSMSConfigList: action.payload,
      });
    }
    case CONFIGURATION.GET_TESTLIST_FROM_CONFIGURATIONLIST: {
      return Object.assign({}, state, {
        testConfigList: action.payload,
      });
    }
    case CONFIGURATION.GET_SMS_TESTLIST_FROM_CONFIGURATIONLIST: {
      return Object.assign({}, state, {
        testSMSConfigList: action.payload,
      });
    }
    case CONFIGURATION.GET_FROMNAME_BY_CLIENTID: {
      return Object.assign({}, state, {
        fromName: action.payload,
      });
    }
    case CONFIGURATION.GET_SEEDLIST_BY_CLIENTID: {
      return Object.assign({}, state, {
        seedList: action.payload,
      });
    }
    case CONFIGURATION.GET_TESTLIST_BY_CLIENTID: {
      return Object.assign({}, state, {
        testList: action.payload,
      });
    }
    case CONFIGURATION.GET_TOEMAIL_BY_CLIENTID: {
      return Object.assign({}, state, {
        replyAddresses: action.payload,
      });
    }
    case CONFIGURATION.GET_FROMEMAIL_BY_CLIENTID: {
      return Object.assign({}, state, {
        fromAddresses: action.payload,
      });
    }
    case CONFIGURATION.GET_TRACKINGPARAMETER_BY_CLIENTID: {
      return Object.assign({}, state, {
        trackingParams: action.payload,
      });
    }
    case CONFIGURATION.GET_DataIntegration_LOG: {
      return Object.assign({}, state, {
        dataintegrationlogs: action.payload,
      });
    }
    case CONFIGURATION.GET_APPENDTRACKINGPARAMS_BY_CLIENTID: {
      return Object.assign({}, state, {
        appendTrackingParams: action.payload,
      });
    }
    case CONFIGURATION.GET_PROVIDER_BYCLIENTID: {
      return Object.assign({}, state, {
        provider: action.payload,
      });
    }
    case CONFIGURATION.IS_LOADING: {
      return Object.assign({}, state, {
        loading: action.payload,
      });
    }
    case CONFIGURATION.IS_GRIDLOADING: {
      return Object.assign({}, state, {
        gridloading: action.payload,
      });
    }
    case CONFIGURATION.GET_EMAILCONFIGFORM_BY_CLIENTID: {
      return Object.assign({}, state, {
        trackingParams: action.payload.trackingParams,
        fromAddresses: action.payload.fromEmailAddress,
        replyAddresses: action.payload.replyToEmailAddress,
        seedConfigList: action.payload.seedConfigList,
        testConfigList: action.payload.testConfigList,
        fromName: action.payload.fromName,
        seedList: action.payload.seedList,
        testList: action.payload.testList,
        appendTrackingParams: action.payload.appendTrackingParams,
        beeCommenting: action.payload.beeCommenting,
        beeAmpSupport: action.payload.beeAmpSupport
      });
    }
    case CONFIGURATION.GET_MENU_BY_CLIENTID: {
      return Object.assign({}, state, {
        menuList: action.payload,
      });
    }
    // Cleared on client switch so nothing reads the previous client's menu. SideBar
    // refetches via getMenu on the clientId change, but getMenu swallows its errors and
    // dispatches nothing on failure, so without this the old rows simply stayed -- the
    // sidebar and anything gating on the menu would describe client A while the user is on
    // client B, with no recovery short of a reload. Empty is the honest interim value:
    // consumers already treat it as "unknown".
    //
    // Only when the client actually CHANGES. DROP_DOWN_CLICK also fires with the current
    // clientId on ordinary navigation -- re-picking the selected client (react-select fires
    // onChange for the already-selected option and handleChange has no same-value guard),
    // and ClientDropDown.componentDidUpdate, which calls onClientChange whenever the
    // clientList REFERENCE changes, as LoadPageData's getClientList refetch makes it do on
    // every transition into or out of File Management, Configuration, Customer Lookup,
    // Database Overview and Email Reports Conglom. Clearing on those left the menu empty
    // with nothing to refill it: SideBar's refetch is guarded on the clientId having
    // changed, so the sidebar rendered zero items for the rest of the session. Unlike the
    // claims, which onClientChange re-requests unconditionally, the menu has no other
    // loader. Same client means the rows are still correct, so leave them alone.
    case COMMON.DROP_DOWN_CLICK: {
      if (Number(action.payload) === Number(state.menuClientId)) {
        return state;
      }
      return Object.assign({}, state, {
        menuList: [],
        menuClientId: action.payload,
      });
    }
    case CONFIGURATION.GET_CONFIGURATION_INTEGRATIONLIST_BY_CLIENTID: {
      return Object.assign({}, state, {
        integrationList: action.payload,
      });
    }
    case CONFIGURATION.GET_CONFIGURATION_INTEGRATIONLIST_BY_PROVIDER_CATEGORIES: {
      return Object.assign({}, state, {
        categorizedIntegrationList: action.payload,
      });
    }
    case CONFIGURATION.GET_CONFIGURATION_PROVIDER_CATEGORIES: {
      return Object.assign({}, state, {
        providerCategories: action.payload,
      });
    }
    case CONFIGURATION.GET_CONFIGURATION_INTEGRATIONPARAMS_BYPROVIDEID: {
      return Object.assign({}, state, {
        integrationParams: action.payload,
      });
    }
    case USERMANAGEMENT.GET_COMPANIES: {
      return Object.assign({}, state, {
        companies: action.payload,
      });
    }
    case PROCESSINGITEMS.GET_PROCESSING_ITEMS: { 
      return Object.assign({}, state, {
        processingItems: action.payload,
      });
    }
    case USERMANAGEMENT.GET_USERS_BY_CLIENT: {
      return Object.assign({}, state, {
        usersByClient: action.payload,
      });
    }
    case USERMANAGEMENT.GET_USER_TRUSTED_DEVICES: {
      return Object.assign({}, state, {
        userTrustedDevices: action.payload,
      });
    }
    case USERMANAGEMENT.ADD_USER: {
      return Object.assign({}, state, {
        addedUser: action.payload,
      });
    }
    case USERMANAGEMENT.UPDATE_USER: {
      return Object.assign({}, state, {
        updatedUser: action.payload,
      });
    }
    case USERMANAGEMENT.GET_USER_BY_USER_ID: {
      return Object.assign({}, state, {
        getUserById: action.payload,
      });
    }
    case USERMANAGEMENT.CHECK_USER_PASSWORD: {
      return Object.assign({}, state, {
        checkUserPassword: action.payload,
      });
    }
    case USERMANAGEMENT.CLIENT_ROLES: {
      return Object.assign({}, state, {
        clientRoles: action.payload,
      });
    }
    case CONFIGURATION.GET_ACCOUNT_MANAGERS: {
      return Object.assign({}, state, {
        accountManagersOptions: action.payload,
      });
    }
    case CONFIGURATION.GET_CLIENT_SETTINGS: {
      return Object.assign({}, state, {
        clientSettings: action.payload,
      });
    }
    case CONFIGURATION.SHOW_WELCOME_POPUP: {
      return Object.assign({}, state, {
        showWelcomePopup: action.payload,
      });
    }
    case USERMANAGEMENT.GET_MANAGE_COLUMNS: {
      return Object.assign({}, state, {
          manage_columns: action.payload
      });
    }
    case CONFIGURATION.GET_SMS_PHONENUMBERS_BY_CLIENTID: {
      return Object.assign({}, state, {
          sms_phone_numbers: action.payload
      });
    }
    case CONFIGURATION.GET_SMS_SMART_ENCODING_STATUS: {
      return Object.assign({}, state, {
          sms_smart_encoding: action.payload
      });
    }
    case CONFIGURATION.GET_SMS_PHONENUMBERS_BY_CLIENTID: {
      return Object.assign({}, state, {
          sms_phone_numbers: action.payload
      });
    }
    case CONFIGURATION.GET_SMSCONFIGFORM_BY_CLIENTID: {
      return Object.assign({}, state, {
        //trackingParams: action.payload.trackingParams,
        fromNumbers: action.payload.fromNumbers,
        fromName: action.payload.fromName,
        helpSMSEmail: action.payload.helpEmail,
        smsUnsubscribeText: action.payload.UnsubscribeText,
        //replyAddresses: action.payload.replyToEmailAddress,
        seedSMSConfigList: action.payload.seedConfigList,
        testSMSConfigList: action.payload.testConfigList,
        seedSMSList: action.payload.seedList,
        testSMSList: action.payload.testList,
        unsubscribeText: action.payload.unsubscribeText,
        //appendTrackingParams: action.payload.appendTrackingParams,
      });
    }

    // Premium Integration Wizard reducers
    case CONFIGURATION.GET_PROVIDER_METADATA_REQUEST: {
      return Object.assign({}, state, {
        providerMetadataLoading: true,
        providerMetadataError: null,
      });
    }
    case CONFIGURATION.GET_PROVIDER_METADATA_SUCCESS: {
      return Object.assign({}, state, {
        providerMetadata: action.payload,
        providerMetadataLoading: false,
        providerMetadataError: null,
      });
    }
    case CONFIGURATION.GET_PROVIDER_METADATA_ERROR: {
      return Object.assign({}, state, {
        providerMetadataLoading: false,
        providerMetadataError: action.payload,
      });
    }
    case CONFIGURATION.TEST_CONNECTION_REQUEST: {
      return Object.assign({}, state, {
        connectionTestLoading: true,
        connectionTestError: null,
      });
    }
    case CONFIGURATION.TEST_CONNECTION_SUCCESS: {
      return Object.assign({}, state, {
        connectionTestResult: action.payload,
        connectionTestLoading: false,
        connectionTestError: null,
      });
    }
    case CONFIGURATION.TEST_CONNECTION_ERROR: {
      return Object.assign({}, state, {
        connectionTestLoading: false,
        connectionTestError: action.payload,
      });
    }
    case CONFIGURATION.CLEAR_PROVIDER_METADATA: {
      return Object.assign({}, state, {
        providerMetadata: null,
        providerMetadataError: null,
      });
    }
    case CONFIGURATION.CLEAR_TEST_CONNECTION_RESULT: {
      return Object.assign({}, state, {
        connectionTestResult: null,
        connectionTestError: null,
      });
    }

    default:
      return state;
  }
};

export default Configuration;
